import * as singleSpa from 'single-spa';
import { socketInstance } from '../helpers/SocketsClientConfigHelper';

const urlTemplates = '/templates';

export function hashPrefix(prefix, name) {
    return function(location) {
        if (window.SGpreventLoad) {
            if (prefix === urlTemplates) {
                return true;
            }
            return false;
        }

        return location.hash.startsWith(`#${prefix}`);
    };
}

export async function loadApp(name, hash, appURL, storeURL, globalEventDistributor) {
    let storeModule = {};
    let customProps = { globalEventDistributor, socketInstance };

    try {
        storeModule = storeURL
            ? await window.System.import(storeURL)
            : {
                  storeInstance: null,
              };
    } catch (e) {
        console.log(`Could not load store of app ${name}.`, e);
    }

    if (storeModule.storeInstance && globalEventDistributor) {
        customProps.store = storeModule.storeInstance;
        globalEventDistributor.registerStore(storeModule.storeInstance);
    }

    singleSpa.registerApplication(name, () => window.System.import(appURL), hashPrefix(hash), customProps);
}
